export default "__VITE_ASSET__BZnFpG7c__"